function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivacypolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-67"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.4,337.8H45.3a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,45.3,55H238.4a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,238.4,337.8ZM45.3,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H238.4a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.7,337.8H261.6a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,261.6,55H454.7a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,454.7,337.8ZM261.6,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H454.7a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.33,314.75c-.84-9.66-10.7-13.27-22.39-12.25S76.18,308.79,77,318.45Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.56,298.09c5.42-.48,7.15-5.06,6.68-10.48s-3-9.63-8.4-9.16-7.15,5.06-6.68,10.48S91.14,298.56,96.56,298.09Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.1,109a5.44,5.44,0,1,1-5.89-4.94A5.44,5.44,0,0,1,340.1,109Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.17,106.34a5.43,5.43,0,1,1-5.88-4.94A5.44,5.44,0,0,1,370.17,106.34Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.25,103.71a5.44,5.44,0,1,1-5.89-4.94A5.44,5.44,0,0,1,400.25,103.71Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.78,139.62a5.44,5.44,0,1,1-5.89-4.94A5.44,5.44,0,0,1,342.78,139.62Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.85,137a5.43,5.43,0,1,1-5.88-4.94A5.43,5.43,0,0,1,372.85,137Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.93,134.36a5.44,5.44,0,1,1-5.89-4.94A5.44,5.44,0,0,1,402.93,134.36Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.46,170.28a5.43,5.43,0,1,1-5.88-4.94A5.42,5.42,0,0,1,345.46,170.28Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.54,167.64a5.44,5.44,0,1,1-5.89-4.94A5.44,5.44,0,0,1,375.54,167.64Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.61,165a5.44,5.44,0,1,1-5.89-4.94A5.44,5.44,0,0,1,405.61,165Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.11,166.78l-61.78,5.4,54.78-66.56L336,110.53a1.18,1.18,0,0,1-1.29-1.09h0a1.19,1.19,0,0,1,1.08-1.29l61.79-5.4-54.79,66.56,56.13-4.91a1.21,1.21,0,0,1,1.3,1.09h0A1.2,1.2,0,0,1,399.11,166.78Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.06,285.61a1.56,1.56,0,0,0-1.35-1.07,10.78,10.78,0,0,1-7.13-3.15c-2.47-2.49-3.92-6.26-4.16-10.74a1.59,1.59,0,0,0-1.58-1.5h0a1.62,1.62,0,0,0-1.61,1.7c.28,5.26,2.06,9.76,5.09,12.79a14,14,0,0,0,8.87,4.07l.23,0A1.6,1.6,0,0,0,400.06,285.61Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.86,304.8c-13.25-1.16-22.81-10.19-25.83-24.29a1.61,1.61,0,0,1,1.28-1.94h0a1.6,1.6,0,0,1,1.84,1.22c2.71,12.67,11.21,20.79,23,21.82,12.92,1.13,26.79-7.37,29.28-28.79a1.6,1.6,0,0,1,1.73-1.43h0a1.59,1.59,0,0,1,1.45,1.76C427.22,293.35,413.94,306.29,396.86,304.8Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.86,266.46h0a1.59,1.59,0,0,1-1.45-1.76c2.38-20.2,15.66-33.15,32.73-31.65,15,1.31,25.05,12.51,26.62,29.38a1.6,1.6,0,0,1-1.5,1.72h0a1.61,1.61,0,0,1-1.68-1.48c-1.45-15.2-10.42-25.27-23.71-26.43C390,235.11,376.07,243.6,373.59,265A1.6,1.6,0,0,1,371.86,266.46Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.51,296.23a21.67,21.67,0,0,1-6.89-1.72,1.61,1.61,0,0,1-.77-2.24h0a1.58,1.58,0,0,1,2-.7,19,19,0,0,0,6.58,1.52c9.79.56,20.13-6.38,21.15-23.14.62-10.33-2.92-18.67-9.52-22.66a1.6,1.6,0,0,1-.61-2.07h0a1.62,1.62,0,0,1,2.27-.67c7.65,4.62,11.75,14,11.05,25.59-1,16.16-11.06,26.92-24.53,26.15Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.27,286.26a1.62,1.62,0,0,1-2.31-.53,32.36,32.36,0,0,1-3.75-18c.94-15.47,10.21-26,22.8-26.18a1.61,1.61,0,0,1,1.64,1.7h0a1.6,1.6,0,0,1-1.56,1.5c-9.34.18-18.72,7.24-19.68,23.17a29.16,29.16,0,0,0,3.34,16.26,1.58,1.58,0,0,1-.48,2.1Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.13,285h0a1.6,1.6,0,0,1,.65-2c4.21-2.53,6.79-7.84,6.83-14.25,0-5.13-1.45-9.47-4.19-12.22a11,11,0,0,0-8.11-3.18c-4.93,0-8.93,2.71-11.14,7.47a1.59,1.59,0,0,1-2,.81h0a1.61,1.61,0,0,1-.9-2.19c2.74-5.83,7.87-9.28,14-9.29a14.24,14.24,0,0,1,10.39,4.12c3.35,3.36,5.17,8.51,5.13,14.51-.06,7.55-3.24,13.89-8.42,17A1.6,1.6,0,0,1,405.13,285Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.61,273.19a1.6,1.6,0,0,1-2.16-1.11c-.11-.43-.19-.88-.26-1.34-.91-6,2.31-11.19,7.48-12.12a7.89,7.89,0,0,1,6.87,1.77,1.55,1.55,0,0,1-.13,2.42l-.1.07a1.59,1.59,0,0,1-2-.15,4.74,4.74,0,0,0-4.11-1c-3.94.71-5.44,4.81-4.88,8.49.06.36.12.71.21,1a1.61,1.61,0,0,1-.95,1.89Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.9,279.35h0a1.49,1.49,0,0,1-1.12-2.27l.14-.22a1.48,1.48,0,0,1,1.37-.69,6.43,6.43,0,0,0,1.5-.09c3.44-.62,5-3.82,5-7.08a1.62,1.62,0,0,1,1.36-1.64h0a1.6,1.6,0,0,1,1.84,1.51c.09,5.22-3,9.53-7.63,10.36A9.21,9.21,0,0,1,398.9,279.35Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.61,273.44a3.88,3.88,0,0,1-3.44-2.93,1.44,1.44,0,0,1,1.51-1.79l.37,0a1.45,1.45,0,0,1,1.23,1,.69.69,0,0,0,.61.52c.77.07.9-1,.92-1.26a1.93,1.93,0,0,0-.21-1.13,1.75,1.75,0,0,1-.4-1.19h0a1.6,1.6,0,0,1,2.83-.89,4.77,4.77,0,0,1,1,3.49C403.77,271.89,401.92,273.64,399.61,273.44Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.53,237.65h0a1.59,1.59,0,0,1-1.45-1.73l1.21-13.87,13.87,1.22a1.59,1.59,0,0,1,1.45,1.73h0a1.6,1.6,0,0,1-1.73,1.46l-10.68-.94-.93,10.68A1.6,1.6,0,0,1,369.53,237.65Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.46,243.42h0a1.59,1.59,0,0,1-1.45-1.73l.93-10.68-10.68-.93a1.6,1.6,0,0,1-1.45-1.74h0a1.59,1.59,0,0,1,1.73-1.45l13.87,1.21L437.2,242A1.6,1.6,0,0,1,435.46,243.42Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.55,318l-13.87-1.21a1.6,1.6,0,0,1-1.45-1.74h0a1.59,1.59,0,0,1,1.73-1.45l10.68.93.93-10.67a1.6,1.6,0,0,1,1.74-1.46h0a1.59,1.59,0,0,1,1.45,1.73Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.3,313.14l-13.87-1.22,1.21-13.86a1.62,1.62,0,0,1,1.74-1.46h0a1.6,1.6,0,0,1,1.45,1.74L364.9,309l10.67.94a1.6,1.6,0,0,1,1.46,1.73h0A1.61,1.61,0,0,1,375.3,313.14Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.73,283.13h0a1,1,0,0,1-1.07-.9l-.74-8.52,8.52-.75a1,1,0,0,1,1.07.9h0a1,1,0,0,1-.9,1.06l-6.56.58.57,6.56A1,1,0,0,1,74.73,283.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.27,279.58h0a1,1,0,0,1-1.07-.89l-.57-6.57-6.57.58a1,1,0,0,1-1.07-.9h0a1,1,0,0,1,.9-1.07l8.52-.74.75,8.52A1,1,0,0,1,115.27,279.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.47,316.29l-8.53.75a1,1,0,0,1-1.07-.9h0a1,1,0,0,1,.9-1.07l6.56-.57-.57-6.56a1,1,0,0,1,.89-1.07h0a1,1,0,0,1,1.07.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.49,319.26,77,320l-.75-8.53a1,1,0,0,1,.9-1.06h0a1,1,0,0,1,1.06.89l.58,6.57,6.56-.58a1,1,0,0,1,1.07.9h0A1,1,0,0,1,85.49,319.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.58,141,82,143.8l-.67-7.63A14.43,14.43,0,0,1,110,133.65l.38,4.44,4.71-.41-.39-4.44a19.14,19.14,0,1,0-38.14,3.34l.67,7.68a7.66,7.66,0,0,0-6.16,8.18l2.33,26.64a7.66,7.66,0,0,0,8.3,7l36.53-3.19a7.66,7.66,0,0,0,7-8.3l-2.33-26.64A7.66,7.66,0,0,0,114.58,141Zm-13.86,20.53.8,9.17a2.74,2.74,0,1,1-5.45.48l-.8-9.18a4.6,4.6,0,1,1,5.45-.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.44,156.39,167.15,151a17.73,17.73,0,0,1-5,0l-3.3,5.37-.63-.17a24.43,24.43,0,0,1-6.1-2.53l-.56-.32,1.39-5.84a.88.88,0,0,1,1.07-.65h0a.88.88,0,0,1,.65,1.06l-1.1,4.55a23.2,23.2,0,0,0,4.47,1.86l3.22-5.26.59.1a17.78,17.78,0,0,0,5.64,0l.58-.1,3.22,5.26a22.69,22.69,0,0,0,4.47-1.86l-1.43-6,.48-.35a17.56,17.56,0,0,0,3.47-3.31.88.88,0,0,1,1.21-.18h0a.87.87,0,0,1,.19,1.25,19.26,19.26,0,0,1-3.37,3.32l1.47,6.13-.57.32a24.52,24.52,0,0,1-6.09,2.53Zm-20.22-11.74c-.27-.31-.54-.64-.8-1l-6.13,1.47-.33-.56a25.2,25.2,0,0,1-2.53-6.1l-.16-.63,5.37-3.3a17.73,17.73,0,0,1,0-5l-5.37-3.29.16-.64a25.13,25.13,0,0,1,2.53-6.09l.33-.57,6.13,1.47a19,19,0,0,1,3.56-3.56l-1.11-4.64a.88.88,0,0,1,.65-1.06h0a.87.87,0,0,1,1.05.65l1.39,5.78-.48.34a17.57,17.57,0,0,0-4,4l-.35.48-6-1.43a22.69,22.69,0,0,0-1.86,4.47l5.25,3.22-.09.58a16,16,0,0,0,0,5.64l.09.59-5.25,3.22a22.85,22.85,0,0,0,1.86,4.46l6-1.43.35.48a16.14,16.14,0,0,0,1,1.31.87.87,0,0,1,0,1.2l0,0A.87.87,0,0,1,150.22,144.65Zm35.74.49-2.26-.54a.88.88,0,0,1-.65-1.06h0a.88.88,0,0,1,1.06-.65l1,.23a22.82,22.82,0,0,0,1.85-4.46l-5.25-3.22.1-.59a16,16,0,0,0,0-5.64l-.1-.58,5.25-3.22a22.65,22.65,0,0,0-1.85-4.47l-6,1.43-.34-.48a17.77,17.77,0,0,0-4-4l-.48-.34,1.43-6a22.65,22.65,0,0,0-4.47-1.85L168,115l-.58-.1a17.78,17.78,0,0,0-5.64,0l-.59.1L158,109.72l-.6.18a.86.86,0,0,1-1.08-.53h0a.88.88,0,0,1,.53-1.14c.44-.14.89-.27,1.33-.39l.63-.17,3.3,5.38a17,17,0,0,1,5,0l3.29-5.38.64.17a24.9,24.9,0,0,1,6.09,2.53l.57.33-1.47,6.13a18.75,18.75,0,0,1,3.56,3.56l6.13-1.47.33.57a24.74,24.74,0,0,1,2.53,6.09l.17.64-5.38,3.29a16.81,16.81,0,0,1,0,5l5.38,3.3-.17.63a24.81,24.81,0,0,1-2.53,6.1Zm-21.58-4.54a8.67,8.67,0,0,1-8.32-8.32,8.58,8.58,0,0,1,7.58-8.76.89.89,0,0,1,1,.88h0a.87.87,0,0,1-.77.86,6.81,6.81,0,1,0,6.35,2.86.85.85,0,0,1,.14-1.14h0a.88.88,0,0,1,1.31.16,8.56,8.56,0,0,1-7.28,13.46Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.31,229.59l-2.13-3.47a11.06,11.06,0,0,1-3.25,0l-2.13,3.47-.41-.11a15.92,15.92,0,0,1-3.94-1.63l-.36-.21.9-3.78a.57.57,0,0,1,.68-.42h0a.57.57,0,0,1,.42.69l-.7,2.94a14.57,14.57,0,0,0,2.89,1.2l2.08-3.39.37.06a11.18,11.18,0,0,0,3.65,0l.37-.06,2.09,3.39a15.38,15.38,0,0,0,2.88-1.2l-.92-3.86.31-.23a11.3,11.3,0,0,0,2.24-2.13.56.56,0,0,1,.78-.12h0a.57.57,0,0,1,.13.8,12.67,12.67,0,0,1-2.18,2.15l1,4-.37.21a15.77,15.77,0,0,1-3.94,1.63ZM95.25,222l-.52-.63-4,.94-.21-.36A15.92,15.92,0,0,1,88.93,218l-.11-.41,3.47-2.13a11.06,11.06,0,0,1,0-3.25l-3.47-2.13.11-.41a15.77,15.77,0,0,1,1.63-3.94l.21-.37,4,1A13.18,13.18,0,0,1,97,204l-.71-3a.56.56,0,0,1,.42-.68h0a.57.57,0,0,1,.68.42l.9,3.73-.32.23a11.19,11.19,0,0,0-2.57,2.57l-.23.31-3.86-.92a15.38,15.38,0,0,0-1.2,2.88l3.39,2.08-.06.38a11.13,11.13,0,0,0-.16,1.82,11.24,11.24,0,0,0,.16,1.83l.06.37-3.39,2.08a15.19,15.19,0,0,0,1.2,2.89l3.86-.93.23.31a9.28,9.28,0,0,0,.67.85.56.56,0,0,1,0,.77l0,0A.56.56,0,0,1,95.25,222Zm23.09.31-1.46-.34a.57.57,0,0,1-.42-.69h0a.56.56,0,0,1,.68-.42l.63.15a14.57,14.57,0,0,0,1.2-2.89l-3.39-2.08.06-.37a11.24,11.24,0,0,0,.16-1.83,11.13,11.13,0,0,0-.16-1.82l-.06-.38,3.39-2.08a14.74,14.74,0,0,0-1.2-2.88l-3.86.92-.23-.31a11.19,11.19,0,0,0-2.57-2.57l-.31-.23.92-3.86a14.74,14.74,0,0,0-2.88-1.2l-2.09,3.39-.37-.06a11.18,11.18,0,0,0-3.65,0l-.37.06-2.08-3.39-.39.12a.56.56,0,0,1-.7-.35h0a.56.56,0,0,1,.34-.73l.86-.26.41-.1,2.13,3.47a11.06,11.06,0,0,1,3.25,0l2.13-3.47.41.1a16.18,16.18,0,0,1,3.94,1.64l.37.21-1,4a12.84,12.84,0,0,1,2.3,2.3l4-1,.21.37a15.77,15.77,0,0,1,1.63,3.94l.11.41-3.47,2.13a11.06,11.06,0,0,1,0,3.25l3.47,2.13-.11.41a15.92,15.92,0,0,1-1.63,3.94Zm-13.94-2.93a5.54,5.54,0,0,1-.48-11,.58.58,0,0,1,.64.57h0a.56.56,0,0,1-.5.56,4.4,4.4,0,1,0,4.9,4.37,4.34,4.34,0,0,0-.8-2.52.57.57,0,0,1,.09-.74h0a.57.57,0,0,1,.85.1,5.54,5.54,0,0,1-4.7,8.7Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-67"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-67",
    cx: 250,
    cy: 415.69,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-67"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.45,145.83H330.89l-23,263.25h32.56a18.72,18.72,0,0,0,18.26-16.8l20.09-229.66A15.15,15.15,0,0,0,363.45,145.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.81,145.83H246.61a18.72,18.72,0,0,0-18.27,16.79L208.25,392.28a15.17,15.17,0,0,0,15.33,16.8H333.77A18.73,18.73,0,0,0,352,392.28l20.09-229.66A15.15,15.15,0,0,0,356.81,145.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.81,145.83H246.61a18.72,18.72,0,0,0-18.27,16.79L208.25,392.28a15.17,15.17,0,0,0,15.33,16.8H333.77A18.73,18.73,0,0,0,352,392.28l20.09-229.66A15.15,15.15,0,0,0,356.81,145.83Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.34,151.21H327.28a4.33,4.33,0,0,0-4,2.76h0a16,16,0,0,1-14.63,10.23H291.51A12.87,12.87,0,0,1,278.66,154h0a3.47,3.47,0,0,0-3.47-2.76H246.14a12.7,12.7,0,0,0-12.41,11.41l-20.1,229.66a10.29,10.29,0,0,0,10.42,11.42h110.2a12.71,12.71,0,0,0,12.41-11.42l20.09-229.66A10.29,10.29,0,0,0,356.34,151.21Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.88,276H251.76a3.74,3.74,0,0,1-3.78-4.14l.39-4.42a4.61,4.61,0,0,1,4.5-4.14H330a3.74,3.74,0,0,1,3.78,4.14l-.38,4.42A4.62,4.62,0,0,1,328.88,276Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.22,295H250.09a3.73,3.73,0,0,1-3.77-4.14l.38-4.42a4.62,4.62,0,0,1,4.5-4.14h77.13a3.74,3.74,0,0,1,3.78,4.14l-.39,4.42A4.62,4.62,0,0,1,327.22,295Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.45,155.51a5.11,5.11,0,0,1-5,4.59,4.14,4.14,0,0,1-4.19-4.59,5.11,5.11,0,0,1,5-4.59A4.14,4.14,0,0,1,305.45,155.51Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.37,155.51a2.8,2.8,0,0,1-2.73,2.51,2.26,2.26,0,0,1-2.29-2.51,2.79,2.79,0,0,1,2.73-2.51A2.27,2.27,0,0,1,303.37,155.51Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.77,163.17h0a1.22,1.22,0,0,1-1.23-1.35l.22-2.46a1.49,1.49,0,0,1,1.46-1.34h0a1.22,1.22,0,0,1,1.23,1.34l-.22,2.46A1.5,1.5,0,0,1,342.77,163.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.53,163.17h0a1.22,1.22,0,0,1-1.23-1.35l.51-5.77a1.49,1.49,0,0,1,1.46-1.34h0a1.22,1.22,0,0,1,1.23,1.34l-.51,5.77A1.5,1.5,0,0,1,353.53,163.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.15,163.17h0a1.22,1.22,0,0,1-1.23-1.35l.36-4.11a1.5,1.5,0,0,1,1.47-1.35h0a1.21,1.21,0,0,1,1.22,1.35l-.36,4.11A1.5,1.5,0,0,1,348.15,163.17Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.64,163.17h-6.76a.68.68,0,0,1-.69-.76l.31-3.63a.85.85,0,0,1,.83-.76h6.76a.68.68,0,0,1,.69.76l-.32,3.63A.83.83,0,0,1,250.64,163.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.77,162.18h0a.69.69,0,0,1-.7-.76l.15-1.66a.84.84,0,0,1,.83-.76h0a.68.68,0,0,1,.69.76l-.14,1.66A.85.85,0,0,1,253.77,162.18Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 294.81,
    cy: 224.63,
    rx: 33.73,
    ry: 30.9,
    transform: "translate(-73.49 266.21) rotate(-43.75)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.92,223.38c-8.48,0-15.65,3.23-16.26,10.24l-.68,7.79h30.73l.68-7.79C310,226.61,303.41,223.38,294.92,223.38Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.2,220.17c3.94,0,5.76-3.19,6.1-7.13s-.91-7.13-4.85-7.13-5.75,3.2-6.1,7.13S291.26,220.17,295.2,220.17Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.36,269.38c-2.09,0-3.86.8-4,2.53l-.17,1.93h7.59l.17-1.93C329.09,270.18,327.46,269.38,325.36,269.38Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.43,268.59c1,0,1.42-.79,1.51-1.76s-.23-1.76-1.2-1.76-1.42.79-1.51,1.76S324.46,268.59,325.43,268.59Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,314H272a5.73,5.73,0,0,1-5.8-6.35h0a7.08,7.08,0,0,1,6.91-6.35h30a5.74,5.74,0,0,1,5.8,6.35h0A7.07,7.07,0,0,1,302,314Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.37,384.82H266.26a6,6,0,0,1-6.12-6.71l2.05-23.42a7.46,7.46,0,0,1,7.29-6.71H301.6a6.05,6.05,0,0,1,6.12,6.71l-2.05,23.42A7.48,7.48,0,0,1,298.37,384.82Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.47,360.6a3.63,3.63,0,0,0-3.68-4,4.48,4.48,0,0,0-4.39,4,3.65,3.65,0,0,0,1.35,3.23l-.7,8.07a2.16,2.16,0,0,0,2.19,2.4,2.67,2.67,0,0,0,2.6-2.4l.71-8.07A4.46,4.46,0,0,0,288.47,360.6Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M301.88,352.86h-4.14l1-11.59a11.41,11.41,0,0,0-11.53-12.64,14.09,14.09,0,0,0-13.74,12.64l-1,11.59h-4.14l1-11.59a18.68,18.68,0,0,1,18.23-16.77,15.14,15.14,0,0,1,15.31,16.77Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.87,287.13,326,286a1.87,1.87,0,0,0-1.88-2.06,2.3,2.3,0,0,0-2.24,2.06l-.1,1.11a.92.92,0,0,0-.89.83l-.26,3a.73.73,0,0,0,.75.82h4.12a.91.91,0,0,0,.89-.82l.26-3A.75.75,0,0,0,325.87,287.13ZM324,284.47a1.41,1.41,0,0,1,1.42,1.55l-.1,1.11h-3.1l.1-1.11A1.73,1.73,0,0,1,324,284.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.85,288.32l-1.44-.3a.27.27,0,0,1-.19-.38l.6-1.42a.28.28,0,0,0-.47-.29l-1.09,1.12a.28.28,0,0,1-.44,0l-.89-1.12c-.19-.24-.6,0-.53.29l.35,1.42a.31.31,0,0,1-.25.38l-1.49.3c-.32.06-.36.51-.05.57l1.44.3a.26.26,0,0,1,.18.38L259,291a.28.28,0,0,0,.47.29l1.09-1.12a.3.3,0,0,1,.44,0l.89,1.12c.19.24.6,0,.52-.29l-.35-1.42a.33.33,0,0,1,.26-.38l1.49-.3C264.12,288.83,264.16,288.38,263.85,288.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.31,288.32l-1.44-.3a.27.27,0,0,1-.19-.38l.6-1.42a.28.28,0,0,0-.47-.29l-1.09,1.12a.28.28,0,0,1-.44,0l-.89-1.12c-.19-.24-.6,0-.52.29l.35,1.42a.32.32,0,0,1-.26.38l-1.49.3c-.32.06-.36.51-.05.57l1.44.3a.27.27,0,0,1,.19.38l-.6,1.42a.28.28,0,0,0,.47.29l1.09-1.12a.3.3,0,0,1,.44,0l.89,1.12c.19.24.6,0,.53-.29l-.35-1.42a.32.32,0,0,1,.25-.38l1.49-.3C273.58,288.83,273.62,288.38,273.31,288.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.77,288.32l-1.43-.3a.26.26,0,0,1-.19-.38l.6-1.42a.28.28,0,0,0-.48-.29l-1.08,1.12a.29.29,0,0,1-.45,0l-.89-1.12c-.19-.24-.6,0-.52.29l.35,1.42a.32.32,0,0,1-.25.38l-1.49.3c-.32.06-.36.51-.05.57l1.43.3a.27.27,0,0,1,.19.38l-.6,1.42a.28.28,0,0,0,.48.29l1.08-1.12a.3.3,0,0,1,.44,0l.9,1.12c.19.24.6,0,.52-.29l-.35-1.42a.33.33,0,0,1,.25-.38l1.49-.3C283,288.83,283.08,288.38,282.77,288.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.24,288.32l-1.44-.3a.27.27,0,0,1-.19-.38l.6-1.42a.28.28,0,0,0-.47-.29l-1.09,1.12a.28.28,0,0,1-.44,0l-.89-1.12c-.19-.24-.6,0-.53.29l.35,1.42a.31.31,0,0,1-.25.38l-1.49.3c-.32.06-.36.51,0,.57l1.44.3a.26.26,0,0,1,.18.38l-.59,1.42a.28.28,0,0,0,.47.29l1.09-1.12a.3.3,0,0,1,.44,0l.89,1.12c.19.24.6,0,.52-.29l-.35-1.42a.33.33,0,0,1,.26-.38l1.49-.3C292.51,288.83,292.55,288.38,292.24,288.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.7,288.32l-1.44-.3a.27.27,0,0,1-.19-.38l.6-1.42a.28.28,0,0,0-.47-.29l-1.09,1.12a.28.28,0,0,1-.44,0l-.89-1.12c-.19-.24-.6,0-.52.29l.35,1.42a.32.32,0,0,1-.26.38l-1.49.3c-.32.06-.36.51-.05.57l1.44.3a.27.27,0,0,1,.19.38l-.6,1.42a.28.28,0,0,0,.47.29l1.09-1.12a.3.3,0,0,1,.44,0l.89,1.12c.19.24.6,0,.53-.29l-.35-1.42a.32.32,0,0,1,.25-.38l1.49-.3C302,288.83,302,288.38,301.7,288.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.16,288.32l-1.44-.3a.26.26,0,0,1-.18-.38l.6-1.42a.28.28,0,0,0-.48-.29l-1.08,1.12a.29.29,0,0,1-.45,0l-.89-1.12c-.19-.24-.6,0-.52.29l.35,1.42a.32.32,0,0,1-.25.38l-1.49.3c-.32.06-.36.51-.05.57l1.43.3a.27.27,0,0,1,.19.38l-.6,1.42a.28.28,0,0,0,.48.29l1.08-1.12a.3.3,0,0,1,.44,0l.89,1.12a.31.31,0,0,0,.53-.29l-.35-1.42a.33.33,0,0,1,.25-.38l1.49-.3C311.43,288.83,311.47,288.38,311.16,288.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.35,267.61H270.59a2.23,2.23,0,0,0-2.18,2,1.8,1.8,0,0,0,1.83,2H288a2.23,2.23,0,0,0,2.18-2A1.81,1.81,0,0,0,288.35,267.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.39,267.61H296.08a2.22,2.22,0,0,0-2.17,2,1.8,1.8,0,0,0,1.82,2H306a2.22,2.22,0,0,0,2.17-2A1.8,1.8,0,0,0,306.39,267.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,358.26a45.29,45.29,0,0,0-16.59,11,19.71,19.71,0,0,0-9.73-4l-.47-.07-.2,2.36.26.1a18.33,18.33,0,0,1,9.33,7.68l.34.56.37-.6a43.46,43.46,0,0,1,16.92-15.56l.23-.12.13-1.56Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Document--inject-67"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.64,161.37a18,18,0,0,0-2.3,7.25L213.45,338.84h46.08l9.26-35.49-3.05-35.5L275,232.36,272,196.87l9.26-35.5Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.95 186.87 277.21 151.37 160.68 151.37 151.43 186.87 154.47 222.36 145.22 257.85 148.26 293.35 139.01 328.84 255.53 328.84 264.79 293.35 261.74 257.85 271 222.36 267.95 186.87",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.95 186.87 277.21 151.37 160.68 151.37 151.43 186.87 154.47 222.36 145.22 257.85 148.26 293.35 139.01 328.84 255.53 328.84 264.79 293.35 261.74 257.85 271 222.36 267.95 186.87",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.95 186.87 151.43 186.87 160.68 151.37 277.21 151.37 267.95 186.87",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.74 257.85 145.22 257.85 154.47 222.36 271 222.36 261.74 257.85",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.53 328.84 139 328.84 148.26 293.35 264.79 293.35 255.53 328.84",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.36,201.7a12.74,12.74,0,0,1-3.68.5,10.25,10.25,0,0,1-4.89-1,1.79,1.79,0,0,0-.91-.25h0a1.81,1.81,0,0,0-.84.22l-.06,0h0l0,0a5.91,5.91,0,0,1-1.42.57,13,13,0,0,1-3.43.43c-.35,0-.69,0-1,0a12.1,12.1,0,0,1-2.65-.47,1.78,1.78,0,0,0-.39-.07,1.6,1.6,0,0,0-1.73,1.59h0v1.08H186a6.34,6.34,0,0,0-6.34,6.35v6.39A6.34,6.34,0,0,0,186,223.4h51.53l.34,0c.55.46,1.13.92,1.75,1.39s1.5,1.12,2.31,1.7a1.62,1.62,0,0,0,1.9,0c6.48-4.7,10.64-7.94,10.64-16.84v-6.4A1.61,1.61,0,0,0,252.36,201.7Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.67,
    y: 200.79,
    width: 64.22,
    height: 19.09,
    rx: 6.35,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.69,198.68a10.31,10.31,0,0,1-4.89-1,1.72,1.72,0,0,0-1.8,0,10.32,10.32,0,0,1-4.9,1,12.79,12.79,0,0,1-3.68-.5,1.6,1.6,0,0,0-2.11,1.52v6.4c0,8.91,4.16,12.15,10.64,16.85a1.62,1.62,0,0,0,1.9,0c6.48-4.7,10.64-7.94,10.64-16.85v-6.4a1.61,1.61,0,0,0-2.12-1.52A12.74,12.74,0,0,1,247.69,198.68Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.69,198.68a10.31,10.31,0,0,1-4.89-1,1.72,1.72,0,0,0-1.8,0,10.32,10.32,0,0,1-4.9,1,12.79,12.79,0,0,1-3.68-.5,1.6,1.6,0,0,0-2.11,1.52v6.4c0,8.91,4.16,12.15,10.64,16.85a1.62,1.62,0,0,0,1.9,0c6.48-4.7,10.64-7.94,10.64-16.85v-6.4a1.61,1.61,0,0,0-2.12-1.52A12.74,12.74,0,0,1,247.69,198.68Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,197.66a10.32,10.32,0,0,1-4.9,1,12.84,12.84,0,0,1-3.68-.5,1.6,1.6,0,0,0-2.11,1.52v6.4c0,8.91,4.16,12.15,10.64,16.85a1.63,1.63,0,0,0,1,.31V197.4A1.74,1.74,0,0,0,241,197.66Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.19,204.36a26,26,0,0,0-10.12,7.13,13.94,13.94,0,0,0-6.53-2.61l-.31,0v1.53l.17.06a13.38,13.38,0,0,1,6.48,5l.25.36.21-.39a24.81,24.81,0,0,1,10.07-10.08l.15-.07v-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.15,161.36h-4.42a4,4,0,0,1-4.05-4.44l.39-4.42a4.93,4.93,0,0,1,4.82-4.44h4.42a4,4,0,0,1,4.06,4.44l-.39,4.42A5,5,0,0,1,275.15,161.36Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.99 152.49 276.03 151.43 273.61 153.65 271.59 151.43 270.44 152.49 272.47 154.71 270.06 156.93 271.02 157.98 273.43 155.76 275.46 157.98 276.6 156.93 274.57 154.71 276.99 152.49",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-67"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.37,199.49c2.56,2.79,5,5.68,7.43,8.59s4.78,5.88,7.12,8.86c.1.13.06.08.08.12s0,.05,0,.06a.36.36,0,0,0,.07.1,1.12,1.12,0,0,0,.73.46,1.27,1.27,0,0,0,.34,0,1.15,1.15,0,0,0,.18,0l.09,0c.05,0,0,0,.16-.06l2.5-1.36c3.36-1.78,6.75-3.52,10.25-5.08l2.93,3.63c-2.82,2.59-5.76,5.84-8.73,8.22l-2.24,1.76a3.8,3.8,0,0,1-.44.31,5.1,5.1,0,0,1-.53.33,10.63,10.63,0,0,1-1.12.56,9.86,9.86,0,0,1-2.42.67,10.34,10.34,0,0,1-5-.5,10,10,0,0,1-2.3-1.17c-.36-.24-.7-.52-1-.79-.17-.14-.31-.3-.47-.45l-.4-.4c-2.65-2.72-5.26-5.46-7.82-8.25s-5.09-5.6-7.51-8.52Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,213.38l2.33-7.49,6.14,3.06s-.9,5.46-5.36,6.41Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.78 203.82 214.32 205.34 212.46 208.95 206.32 205.89 208.78 203.82",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.09,201.53c-.66,3.18-1.48,6.33-2.33,9.47s-1.78,6.25-2.75,9.36l-.36,1.17-.18.58a1.15,1.15,0,0,1-.1.24,3.34,3.34,0,0,0-.19,1,3.55,3.55,0,0,0,.58,2.05,6.33,6.33,0,0,0,.65.75l.83.91,1.64,1.83c1.07,1.24,2.15,2.48,3.17,3.78l-3.49,4c-1.44-.82-2.82-1.71-4.2-2.59l-2.05-1.36-1-.69c-.34-.24-.62-.4-1.17-.85a11.65,11.65,0,0,1-3.84-6.45,12.43,12.43,0,0,1-.19-3.9c0-.32.1-.68.15-1l.11-.6.21-1.2c.56-3.21,1.16-6.41,1.83-9.59s1.39-6.35,2.24-9.48Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.63,232.35l4.12-2.11,1.82,7s-3.31,1.27-5.87-.36Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "151.45 227.99 151.64 234.43 147.03 237.44 145.43 230.37 151.45 227.99",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.94,168.47c.1.49.45.84.77.78s.51-.52.41-1-.45-.84-.77-.78S164.84,168,164.94,168.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.34,169.32a18.21,18.21,0,0,0,3.23,3.76,2.92,2.92,0,0,1-2.28.93Z",
    style: {
      fill: "#a02724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.57,166.09a.3.3,0,0,1-.22-.5,3,3,0,0,1,2.53-1,.3.3,0,0,1,.24.35.29.29,0,0,1-.34.24h0a2.35,2.35,0,0,0-2,.8A.32.32,0,0,1,162.57,166.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.52,175.44c1.1,4.59,2.21,13-1.73,16.05,0,0,1.54,4.66,12,4.66,11.5,0,5.5-3,5.5-3-6.28-1.22-6.12-6.67-5-10.24Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.56,192.34c-.68-1.27-1.44-2.73.12-3.19,1.72-.5,12.75-1.43,16-.49-1,1.77.69,4,.69,4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.7 406.92 163.91 406.92 164.63 392.4 157.41 392.4 156.7 406.92",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.91 404.92 118.22 405.31 122.66 391 115.35 390.61 110.91 404.92",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,404.73l-6.89-1.49a.54.54,0,0,0-.61.3l-2.39,5.19a.91.91,0,0,0,.66,1.28c2.41.48,3.61.59,6.64,1.25,1.86.4,6.07,1.43,8.64,2s3.46-1.91,2.46-2.37c-4.5-2.05-6.38-3.86-7.6-5.55A1.55,1.55,0,0,0,118,404.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.53,406.19h-6.85a.55.55,0,0,0-.53.43l-1.24,5.57a.91.91,0,0,0,.9,1.12c2.47,0,6-.19,9.15-.19,3.63,0,6.76.2,11,.2,2.57,0,3.29-2.6,2.21-2.84-4.91-1.07-8.91-1.19-13.15-3.8A2.94,2.94,0,0,0,163.53,406.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.72,193.61c-5.44,2.59-6.92,18.29-6.92,18.29l13.47,6.22a25.78,25.78,0,0,0,3.6-12.67C146.14,197.34,141.29,191,135.72,193.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,203.29c-2.43,3.78-2.2,9.62-1.36,14.55l.6.28a25.83,25.83,0,0,0,3.6-12.67c0-.48,0-1,0-1.43Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.31,193.23s6.68,7.54.37,54.2H140.15c-.23-5.15,3-30.26-2-54.52a88.21,88.21,0,0,1,11.22-1.42,125.53,125.53,0,0,1,14.26,0A64,64,0,0,1,173.31,193.23Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.31,193.23s6.68,7.54.37,54.2H140.15c-.23-5.15,3-30.26-2-54.52a88.21,88.21,0,0,1,11.22-1.42,125.53,125.53,0,0,1,14.26,0A64,64,0,0,1,173.31,193.23Z",
    style: {
      fill: "#fafafa",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.24,207.49l-.12-.11-6.67-3.56c-.68,10.27,3.91,16.71,6.64,19.52A143.39,143.39,0,0,0,176.24,207.49Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.63 392.4 164.26 399.89 157.04 399.89 157.41 392.4 164.63 392.4",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.35 390.62 122.66 391 120.37 398.38 113.06 397.99 115.35 390.62",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.2,170.78c1.61,6,2.25,9.61,6,12.11,5.58,3.76,12.52-.56,12.74-6.93.19-5.73-2.47-14.6-8.92-15.81A8.49,8.49,0,0,0,148.2,170.78Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.79,247.43s-7.12,47.91-11,65.87C146.49,333,123.55,398,123.55,398l-11.23-2.43s14.39-53,18-80.48c1.4-10.73,3.09-28,5.23-42.43,2.07-14,4.62-25.22,4.62-25.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.24,394.25s-2.1,4.06-2.1,4.06l-12.62-2.74,1.06-3.79Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.24,394.25s-2.1,4.06-2.1,4.06l-12.62-2.74,1.06-3.79Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.29,264.5c-8.23,1.61-7.36,32.3-6.37,48.08,2.38-11.16,5.85-32.62,8.22-47.86A2.8,2.8,0,0,0,157.29,264.5Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.68,247.43s3.35,46.88,2.67,66c-.71,19.89-10.14,85-10.14,85H155.59s-.39-64-.86-83.49c-.52-21.3-3.09-67.52-3.09-67.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.25,394.21c.05,0-.6,4.41-.6,4.41H154.73l-.35-3.94Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.25,394.21c.05,0-.6,4.41-.6,4.41H154.73l-.35-3.94Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.4,202c0,12.58,6.69,17.76,6.69,17.76L187,209.14a89.8,89.8,0,0,0-8.79-12.23C171.9,189.68,169.4,193.92,169.4,202Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.52,178.24a4.1,4.1,0,0,1-2.82,2.6,3.38,3.38,0,0,0-2.69,3l0,0A8.66,8.66,0,0,0,166.52,178.24Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.7,158.83c2.24-2.83-1.21-3-1.21-3,.9-3.37-3.14-1.56-3.14-1.56-2.42-3.34-3.79.73-3.79.73-2.51-2.83-3,1.79-3,1.79-2.52-3.59-3.8,1.59-3.8,1.59-2.32-3.73-3.74,1.12-3.74,1.12-4.79-1.71-2.52,3.27-2.52,3.27-4.08.11-.8,3.28-.8,3.28-4.9,0-.58,2.81-.58,2.81-3.89,2.55,1,3.24,1,3.24-3.17,5,2.28,3.12,2.28,3.12-2.21,4.92,2.68,2.75,2.68,2.75-.31,4.74,2.42,3.45,3.74,2.57.25,1,.73,2,1.61,2.08,1.71.23,2-3,2-3s1.58,1.24,2.91.57.83-2.36.83-2.36a1.67,1.67,0,0,0,2,0c.57-.44.57-3.62-.15-4.74l2.6-1s1.93-.27,1.07-2.82a7.42,7.42,0,0,1-.13-4.55c2.94-1.38.52-3,.52-3C167.49,159.53,163.7,158.83,163.7,158.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.43,171a7,7,0,0,0,2.53,3.74c1.63,1.22,2.85,0,2.73-1.83-.1-1.66-1.08-4.29-2.88-4.79S158,169.23,158.43,171Z",
    style: {
      fill: "#b55b52"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacypolicy);
export default __webpack_public_path__ + "static/media/Privacypolicy.4decfd06d68977629fb47432017879f0.svg";
export { ForwardRef as ReactComponent };